import React, { Component } from 'react'
import { Button } from 'advenio-components'
import styled from 'styled-components'
import PropTypes from 'prop-types' //eslint-disable-line

const NapContainer = styled.div`
  width: 80%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const Span = styled.span`
    color: #9B9B9B;
    margin-bottom: 20px;
  `


class Nap extends Component {
  constructor(props) {
    super(props)
  }

  onClick = () => {
    this.props.setExtraData(this.props.child.checkin.id)
    const params = {
      category_id: this.props.category
    }
    this.props.postActivity(this.props.child.checkin.id, params)
  }

  selectChildren = () => {
    this.props.goToView('kidsToSleep', this.props.view,'')
  }

  render() {
    return (
      <NapContainer>
        <Span>¿Iniciar Siesta?</Span>
        {this.props.group ? '' :
          <Button
            primary
            style={{ marginBottom: '20px', width: '40%' }}
            onClick={this.onClick}
           >
            {'Solo '+this.props.child.first_name + ' ' + this.props.child.last_name_paternal}
          </Button>
        }
        { this.props.group ?
          <Button
            primary={this.props.group}
            ghost={!this.props.group}
            style={{ width: '40%' }}
            onClick={this.selectChildren}
          >
            Elegir Alumnos
          </Button> : ''
        }
      </NapContainer>
    )
  }
}

Nap.propTypes = {
  goToView: PropTypes.func.isRequired,
  setExtraData: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  child: PropTypes.object,
}

Nap.defaultProps = {
  child: {},
}

export default Nap



// WEBPACK FOOTER //
// ./src/Components/Activity/Nap.jsx